module.exports = [
	{
		"name": "META-INF/MANIFEST.MF",
		"uncompressedSize": 2760,
		"compressedSize": 1103
	},
	{
		"name": "META-INF/ELSDOERF.SF",
		"uncompressedSize": 2881,
		"compressedSize": 1173
	},
	{
		"name": "res/drawable/ic_collapse_expand.png",
		"uncompressedSize": 1158,
		"compressedSize": 1158
	},
	{
		"name": "res/drawable/ic_dialog_alert.png",
		"uncompressedSize": 717,
		"compressedSize": 717
	},
	{
		"name": "res/drawable/ic_dialog_info.png",
		"uncompressedSize": 898,
		"compressedSize": 898
	},
	{
		"name": "res/drawable/ic_dialog_info_btn.xml",
		"uncompressedSize": 560,
		"compressedSize": 250
	},
	{
		"name": "res/drawable/ic_dialog_info_btn_normal.png",
		"uncompressedSize": 935,
		"compressedSize": 935
	},
	{
		"name": "res/drawable/ic_dialog_info_btn_pressed.png",
		"uncompressedSize": 880,
		"compressedSize": 880
	},
	{
		"name": "res/drawable/ic_menu_help.png",
		"uncompressedSize": 2587,
		"compressedSize": 2587
	},
	{
		"name": "res/drawable/ic_menu_refresh.png",
		"uncompressedSize": 1664,
		"compressedSize": 1664
	},
	{
		"name": "res/drawable/ic_menu_view.png",
		"uncompressedSize": 1760,
		"compressedSize": 1760
	},
	{
		"name": "res/drawable/ic_menu_windows.png",
		"uncompressedSize": 1121,
		"compressedSize": 1121
	},
	{
		"name": "res/drawable/icon.png",
		"uncompressedSize": 3398,
		"compressedSize": 3398
	},
	{
		"name": "res/layout/by_act_child_row.xml",
		"uncompressedSize": 1676,
		"compressedSize": 648
	},
	{
		"name": "res/layout/by_act_group_row.xml",
		"uncompressedSize": 1588,
		"compressedSize": 611
	},
	{
		"name": "res/layout/by_pkg_child_row.xml",
		"uncompressedSize": 1896,
		"compressedSize": 694
	},
	{
		"name": "res/layout/by_pkg_group_row.xml",
		"uncompressedSize": 1484,
		"compressedSize": 582
	},
	{
		"name": "res/layout/detail_toast.xml",
		"uncompressedSize": 1616,
		"compressedSize": 587
	},
	{
		"name": "res/layout/help.xml",
		"uncompressedSize": 1112,
		"compressedSize": 431
	},
	{
		"name": "res/layout/list.xml",
		"uncompressedSize": 1168,
		"compressedSize": 486
	},
	{
		"name": "res/layout/receiver_info_panel.xml",
		"uncompressedSize": 1612,
		"compressedSize": 562
	},
	{
		"name": "AndroidManifest.xml",
		"uncompressedSize": 2972,
		"compressedSize": 992
	},
	{
		"name": "resources.arsc",
		"uncompressedSize": 364080,
		"compressedSize": 364080
	},
	{
		"name": "res/drawable-hdpi/ic_collapse_expand.png",
		"uncompressedSize": 2123,
		"compressedSize": 2123
	},
	{
		"name": "res/drawable-hdpi/ic_dialog_alert.png",
		"uncompressedSize": 1699,
		"compressedSize": 1699
	},
	{
		"name": "res/drawable-hdpi/ic_dialog_info.png",
		"uncompressedSize": 1445,
		"compressedSize": 1445
	},
	{
		"name": "res/drawable-hdpi/ic_dialog_info_btn_normal.png",
		"uncompressedSize": 1142,
		"compressedSize": 1142
	},
	{
		"name": "res/drawable-hdpi/ic_dialog_info_btn_pressed.png",
		"uncompressedSize": 1060,
		"compressedSize": 1060
	},
	{
		"name": "res/drawable-hdpi/ic_menu_help.png",
		"uncompressedSize": 2680,
		"compressedSize": 2680
	},
	{
		"name": "res/drawable-hdpi/ic_menu_refresh.png",
		"uncompressedSize": 2925,
		"compressedSize": 2925
	},
	{
		"name": "res/drawable-hdpi/ic_menu_view.png",
		"uncompressedSize": 2264,
		"compressedSize": 2264
	},
	{
		"name": "res/drawable-hdpi/ic_menu_windows.png",
		"uncompressedSize": 1991,
		"compressedSize": 1991
	},
	{
		"name": "res/drawable-hdpi/icon.png",
		"uncompressedSize": 7611,
		"compressedSize": 7611
	},
	{
		"name": "classes.dex",
		"uncompressedSize": 643408,
		"compressedSize": 262402
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/sampleAPK2.json
// module id = ./src/pages/sampleAPK2.json
// module chunks = 4016850265702045000